(function () {
  var SERUM_VARIANT_ID = 45557991571634;
  var GUA_SHA_VARIANT_ID = 47566929526962;
  var TRIGGER_QTY = 2;
  var isSyncing = false;
  var syncQueued = false;

  var originalFetch = window.fetch.bind(window);

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var isCartMutation = /\/(cart)\/(add|change|update|clear)(\.js)?/.test(url);

    var result = originalFetch.apply(window, args);

    if (isCartMutation && !isSyncing) {
      result.then(function (response) {
        if (response.ok) setTimeout(syncBundle, 200);
        return response;
      })['catch'](function () {});
    }

    return result;
  };

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(syncBundle, 800);
  });

  // --- Checkout guard -------------------------------------------------
  // Blocks navigation to /checkout until the cart has been reconciled, so
  // an order can never be placed holding the free gift / gua sha without
  // the qualifying bottle quantity (fixes customers removing the 2 paid
  // bottles after the freebies were added, then checking out with just
  // the gua sha or a single bottle).
  document.addEventListener('submit', interceptCheckoutSubmit, true);
  document.addEventListener('click', interceptCheckoutClick, true);

  function waitForIdle() {
    return new Promise(function (resolve) {
      (function poll() {
        if (!isSyncing) return resolve();
        setTimeout(poll, 50);
      })();
    });
  }

  function interceptCheckoutSubmit(e) {
    var form = e.target;

    // Let the programmatic resubmission (below) through untouched - without
    // this guard, form.requestSubmit() would re-fire this same listener and
    // loop forever.
    if (form.__bundleGuardBypass) {
      form.__bundleGuardBypass = false;
      return;
    }

    var submitter = e.submitter;
    var name = submitter && (submitter.getAttribute('name') || submitter.name);
    if (name !== 'checkout') return;

    e.preventDefault();
    e.stopPropagation();

    waitForIdle().then(syncBundle).then(function () {
      form.__bundleGuardBypass = true;
      if (typeof form.requestSubmit === 'function') {
        // requestSubmit(submitter) resubmits as if the button itself was
        // clicked, so name="checkout" is correctly included in the POST -
        // form.submit() silently drops the clicked button's name/value and
        // Shopify's /cart endpoint won't know to redirect to checkout.
        form.requestSubmit(submitter);
      } else {
        // Fallback for browsers without requestSubmit: manually append the
        // button's name/value as a hidden field before the native submit.
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.value = submitter.value || '';
        form.appendChild(hidden);
        HTMLFormElement.prototype.submit.call(form);
      }
    });
  }

  function interceptCheckoutClick(e) {
    var link = e.target.closest && e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    waitForIdle().then(syncBundle).then(function () {
      window.location.href = link.href;
    });
  }
  // ---------------------------------------------------------------------

  function syncBundle() {
    if (isSyncing) { syncQueued = true; return Promise.resolve(); }
    isSyncing = true;
    syncQueued = false;

    return originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var customerSerumQty = 0;
        var autoSerumItem = null;
        var guaShaItem = null;

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.variant_id == SERUM_VARIANT_ID) {
            if (item.properties && item.properties._auto_added_free === 'true') {
              autoSerumItem = item;
            } else {
              customerSerumQty += item.quantity;
            }
          }
          if (item.variant_id == GUA_SHA_VARIANT_ID) guaShaItem = item;
        }

        var bundleActive = customerSerumQty >= TRIGGER_QTY;
        var addItems = [];
        var removeKeys = [];

        if (bundleActive && !autoSerumItem) {
          addItems.push({ id: SERUM_VARIANT_ID, quantity: 1, properties: { _bundle_gift: '90-Day Stack', _auto_added_free: 'true' } });
        } else if (!bundleActive && autoSerumItem) {
          removeKeys.push(autoSerumItem.key);
        }

        if (bundleActive && !guaShaItem) {
          addItems.push({ id: GUA_SHA_VARIANT_ID, quantity: 1, properties: { _bundle_gift: '90-Day Stack', _auto_added: 'true' } });
        } else if (!bundleActive && guaShaItem) {
          removeKeys.push(guaShaItem.key);
        }

        if (!addItems.length && !removeKeys.length) return null;

        var chain = Promise.resolve();

        // Both additions go out in a single atomic /cart/add.js call (using
        // the multi-item `items` array) instead of two separate sequential
        // requests. Items added via separate async calls can land in
        // different inventory reservation batches, which is what was
        // causing Shopify to open a second fulfillment order (and a second
        // shipping label) for the gua sha. One atomic call keeps everything
        // in the same reservation batch and the same fulfillment order.
        if (addItems.length) {
          chain = chain.then(function () {
            return originalFetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: addItems })
            });
          });
        }

        removeKeys.forEach(function (key) {
          chain = chain.then(function () {
            return originalFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        });

        return chain.then(function () { refreshCartUI(); });
      })
      ['catch'](function (err) { console.warn('[Bundle Gift] sync error:', err); })
      .then(function () {
        isSyncing = false;
        if (syncQueued) return syncBundle();
      });
  }

  function refreshCartUI() {
    originalFetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) return;
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
        var selectors = ['cart-drawer', '#cart-drawer', '[data-cart-drawer]'];
        for (var s = 0; s < selectors.length; s++) {
          var newEl = newDoc.querySelector(selectors[s]);
          var curEl = document.querySelector(selectors[s]);
          if (newEl && curEl) { curEl.innerHTML = newEl.innerHTML; break; }
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      ['catch'](function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }
})();
